import { SvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

export const PastPinIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width="18" height="18" viewBox="0 0 18 18" data-testid="PastPinIcon" {...props}>
      <path d="M7.6922 2.60625C7.10354 2.24169 6.37148 2.11167 5.64989 2.30502C4.96438 2.4887 4.41661 2.92985 4.08275 3.49655L5.7427 4.45423L2.35985 5.36066L1.45398 1.97992L2.87006 2.79691C3.38307 1.91974 4.22846 1.2365 5.28755 0.952719C6.99201 0.496009 8.73443 1.21207 9.65806 2.60625L7.6922 2.60625Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.546 11.5729V12.9817H11.024V16.2019L10.3196 16.9063L9.61516 16.2019V12.9817H6.09312V11.5729L7.50194 10.1641V5.23327H6.79753V3.82445H13.8416V5.23327H13.1372V10.1641L14.546 11.5729ZM8.10068 11.5729H12.5384L11.7284 10.7629V5.23327H8.91075V10.7629L8.10068 11.5729Z"
      />
    </SvgIcon>
  );
};
